/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCheckboxMixed = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M0 2.222C0 .995.995 0 2.222 0h19.556C23.005 0 24 .995 24 2.222v19.556A2.222 2.222 0 0 1 21.778 24H2.222A2.222 2.222 0 0 1 0 21.778V2.222zM2.222 2C2.1 2 2 2.1 2 2.222v19.556c0 .123.1.222.222.222h19.556c.123 0 .222-.1.222-.222V2.222C22 2.1 21.9 2 21.778 2H2.222zm3.667 9H18.11v2H5.89v-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCheckboxMixed as CheckboxMixed };
